import gql from 'graphql-tag'

export const fetchCompaniesSelect = () => {
	return {
		query: gql`
			{
				companies: companies(
					where: { active: { _eq: true } }
					order_by: { company_name: asc }
				) {
					id
					company_name
				}
			}
		`
	}
}
